/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import DashboardRoutes from '../views/dashboard/dashboard.routes'
import RaceRoutes from '../views/race/race.routes'
import FavoritesRoutes from '../views/favorites/favorites.routes'
import LoginRoutes from '../views/login/login.routes'
import ImageRoutes from '../views/image/image.routes'
import ComparisonRoutes from '../views/comparison/comparison.routes'
import CompareRoutes from '../views/compare/compare.routes'

export default () => {
  DashboardRoutes()
  LoginRoutes()
  RaceRoutes()
  FavoritesRoutes()
  ImageRoutes()
  ComparisonRoutes()
  CompareRoutes()
}
